import { countSelfieCyclesUntilTarget, computeGoalMonthlyAmount } from './goalMonthlyPlan';
import { evaluateGoalSavingsSoftWarning } from './groupBudgetHeadroom';
import { parsePtNumber } from './money';
import { todayISO } from './selfiePeriod';

const MONTHS_PT = [
  'jan.',
  'fev.',
  'mar.',
  'abr.',
  'mai.',
  'jun.',
  'jul.',
  'ago.',
  'set.',
  'out.',
  'nov.',
  'dez.',
];

/** `YYYY-MM` → último dia do mês em ISO `YYYY-MM-DD`. */
export function monthValueToTargetDate(ym) {
  if (!ym || !/^\d{4}-\d{2}$/.test(ym)) return '';
  const [y, m] = ym.split('-').map(Number);
  const lastDay = new Date(y, m, 0).getDate();
  return `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
}

/** ISO date → `YYYY-MM` para input type=month. */
export function targetDateToMonthValue(iso) {
  if (!iso) return '';
  const match = String(iso).match(/^(\d{4}-\d{2})/);
  return match ? match[1] : '';
}

export function formatMonthLabel(ym) {
  if (!ym || !/^\d{4}-\d{2}$/.test(ym)) return '—';
  const [y, m] = ym.split('-').map(Number);
  return `${MONTHS_PT[(m || 1) - 1]} ${y}`;
}

export function formatDateLabelFromIso(iso) {
  return formatMonthLabel(targetDateToMonthValue(iso));
}

/**
 * Snapshot live do plano mensal + soft warning Poupança.
 */
export function buildGoalMonthlyPreview({
  amountInput,
  monthValue,
  groups,
  startDate,
  selfieDayOfMonth,
  cycleStartISO,
  excludePotMonthly = 0,
}) {
  const targetAmount = parsePtNumber(amountInput);
  const targetDate = monthValueToTargetDate(monthValue);
  if (!targetAmount || targetAmount <= 0 || !targetDate) {
    return {
      monthly: null,
      cycles: null,
      targetAmount: targetAmount || 0,
      targetDate: '',
      soft: { over: false },
    };
  }

  const startISO =
    typeof startDate === 'string' ? startDate : undefined;

  const cycles = countSelfieCyclesUntilTarget({
    fromISO: startISO || todayISO(),
    targetISO: targetDate,
    selfieDayOfMonth,
    cycleStartISO,
  });

  const monthly = computeGoalMonthlyAmount(targetAmount, targetDate, {
    startDate,
    selfieDayOfMonth,
    cycleStartISO,
  });

  const soft = evaluateGoalSavingsSoftWarning({
    groups,
    monthly,
    cycles,
    excludePotMonthly,
  });

  return {
    monthly,
    cycles,
    targetAmount,
    targetDate,
    soft,
  };
}
